/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Necessary_DescriptionInputs */

const da_consent_necessary_description = /** @type {(inputs: Consent_Necessary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Holder dig logget ind og husker dit valg her. Tjenesten virker ikke uden dem, så de kan ikke slås fra.`)
};

/** @type {(inputs: Consent_Necessary_DescriptionInputs) => LocalizedString} */
const en_consent_necessary_description = da_consent_necessary_description;

/**

* @param {Consent_Necessary_DescriptionInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_necessary_description = /** @type {((inputs?: Consent_Necessary_DescriptionInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Necessary_DescriptionInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_necessary_description(inputs)
	return /** @type {LocalizedString} */ ("Holder dig logget ind og husker dit valg her. Tjenesten virker ikke uden dem, så de kan ikke slås fra.")
});